export default __webpack_public_path__ + "static/media/CompletedPatientFill.9aa09cd7.svg";